var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { OptionItem } from '../../../../diagram/utils/option-item';
import * as _ from 'lodash';
import { RelationType } from './relation-type';
var RelationTypeOptionService = /** @class */ (function () {
    function RelationTypeOptionService() {
        this.optionList = [
            new OptionItem(RelationType.None, 'None'),
            new OptionItem(RelationType.And, 'AND'),
            new OptionItem(RelationType.Or, 'OR')
        ];
    }
    RelationTypeOptionService.prototype.getOptions = function () {
        return this.optionList;
    };
    RelationTypeOptionService.prototype.getOptionNameByKey = function (key) {
        // eslint-disable-next-line eqeqeq
        var option = _.find(this.optionList, function (s) { return s.key == key; });
        return option ? option.name : '';
    };
    RelationTypeOptionService = __decorate([
        Injectable()
    ], RelationTypeOptionService);
    return RelationTypeOptionService;
}());
export { RelationTypeOptionService };
